import * as React from 'react';

const SvgCalendar = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={'1em'}
    height={'1em'}
    viewBox={'0 0 18 20'}
    {...props}
  >
    <path
      d='M3 20h12a3 3 0 0 0 3-3V5a2 2 0 0 0-2-2h-2V1a1 1 0 1 0-2 0v2H6V1a1 1 0 1 0-2 0v2H2a2 2 0 0 0-2 2v12a3 3 0 0 0 3 3Zm-1-9.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5V17a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgCalendar;
